const clientEmailTemplateTypeOfNone = (clientTitle, expertInfo, availabilityStore, userPosition, userPhoneNumbers) => {
  return `
    <p>
      Dear ${clientTitle}
    </p>

    <p>
      I am pleased to confirm the consultation call scheduled with ${expertInfo}
    </p>

    <p>
      In case of any queries, please do not hesitate to contact me
      via email or via phone.
    </p>  

    <p>
      Please accept this invitation before the time of consultation.
    </p>  

    <p>
      ${availabilityStore.userStore.user.fullName}<br>
      ${userPosition}<br>
      ${availabilityStore.userStore.user.email}<br>
      ${userPhoneNumbers.join('<br>')}<br>
      <a href="https://www.atheneum-partners.com">www.atheneum-partners.com</a>
    </p>
   `;
};

export default clientEmailTemplateTypeOfNone;